import React from 'react';

const BolderText = ({ stroke, ...props }) => {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5 8.4375H11.1875C11.9334 8.4375 12.6488 8.73382 13.1762 9.26126C13.7037 9.78871 14 10.5041 14 11.25C14 11.9959 13.7037 12.7113 13.1762 13.2387C12.6488 13.7662 11.9334 14.0625 11.1875 14.0625H5V3.375H10.3438C11.0151 3.375 11.6589 3.64168 12.1336 4.11639C12.6083 4.59109 12.875 5.23492 12.875 5.90625C12.875 6.57758 12.6083 7.22141 12.1336 7.69611C11.6589 8.17082 11.0151 8.4375 10.3438 8.4375"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BolderText;
